/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import util from "../../../../../../utils/es5Utils";

export const BLOCK_NAME = 'snap_tableview_select_row_V3';

function defineBlock(context) {
    return {
        selectionMode: 'FIRST',

        init: function () {
            let selectTableDropdown = new Blockly.FieldWidgetsDropdown(context, 'tableview', undefined, '- select -');
            let modeDropdown = new Blockly.FieldDropdown(
                [['first row', 'FIRST'], ['last row', 'LAST'], ['next row', 'NEXT'], ['previous row', 'PREVIOUS'], ['by index', 'INDEX']],
                this.onModeChanged_.bind(this)
            );

            this.appendDummyInput('WIDGET')
                .appendField("select in")
                .appendField(selectTableDropdown, "ID")
                .appendField(modeDropdown, "MODE");

            this.appendStatementInput('ON_SUCCESS').appendField("on success");
            this.appendStatementInput('ON_ERROR').appendField("on error");

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Select a row in a TableView widget.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#Table`);
        },

        onModeChanged_: function (newMode) {
            if (newMode === this.selectionMode) return newMode;

            this.removeExtraInputs_();
            this.selectionMode = newMode;

            if (newMode === 'INDEX') {
                this.addIndexInput_();
            }

            return newMode;
        },

        removeExtraInputs_: function () {
            if (this.getInput('INDEX_INPUT')) {
                this.removeInput('INDEX_INPUT');
            }
        },

        addIndexInput_: function () {
            let indexInput = this.appendValueInput('INDEX_INPUT')
                .appendField("row #");

            this.moveInputBefore('INDEX_INPUT', 'ON_SUCCESS');

            let inputBlock = this.workspace.newBlock("math_number");
            inputBlock.setShadow(true);
            inputBlock.setMovable(false);

            indexInput.connection.connect(inputBlock.outputConnection);

            if (this.rendered) {
                inputBlock.initSvg();
                inputBlock.render();
                this.initSvg();
                this.render();
            }
        },

        mutationToDom: function () {
            let container = Blockly.utils.xml.createElement('mutation');
            container.setAttribute('selectionMode', this.selectionMode);
            container.setAttribute('ID', this.getFieldValue('ID'));
            return container;
        },

        domToMutation: function (xml) {
            let selectionMode = xml.getAttribute("selectionMode") || 'FIRST';

            this.selectionMode = selectionMode;

            if (this.getField('MODE')) {
                this.getField('MODE').setValue(selectionMode);
            }

            if (selectionMode === 'INDEX') {
                this.addIndexInput_();
            }
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue('ID');
            let mode = block.getFieldValue('MODE');

            let onSuccess = Blockly.JavaScript.statementToCode(block, 'ON_SUCCESS');
            let onError = Blockly.JavaScript.statementToCode(block, 'ON_ERROR');

            let index = 'null';
            if (mode === 'INDEX') {
                index = Blockly.JavaScript.valueToCode(block, 'INDEX_INPUT', Blockly.JavaScript.ORDER_NONE) || '1';
            }

            return `Snap.widgets.tableview.selectRecord("${id}", "${mode}", ${index}, function() {\n${onSuccess}}, function() {\n${onError}});\n`;
        }
    }
}

const SelectRow = function (props) {
    const name = BLOCK_NAME;
    SelectRow.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    let widgets = util.widgetsOfType(props.context, "tableview");

    if (widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {
                props.widget?.id !== undefined
                    ? <field name="ID">{props.widget.id}</field>
                    : null
            }
        </block>
    );
}

SelectRow.propTypes = {
    context: PropTypes.object,
    widget: PropTypes.object
};

export default SelectRow;
